
<ng-container *ngIf="params?.statusVisible || params?.avl || params?.source || isDateFormat; else noStatus">
  <div *ngIf="isDateFormat">
    <span class="font-14">{{(params.value | date:'MM/dd/yyyy') || '&#8212;'}}</span>
  </div>
  <button *ngIf="params?.statusVisible" class="btn btn-visible">{{params.value}}</button>
  <div *ngIf="params?.avl" class="d-flex align-items-center gap-2">
    <span class="text-gray-color w-75 d-inline-block text-truncate">{{params.data.vendorName || '&#8212;' }}</span>
    <button *ngIf="params.data.isVendorAVL" class="btn btn-AVL">AVL</button>
  </div>
  <div *ngIf="params?.source">
    <a *ngIf="params.value" class="hand font-14 text-decoration-underline text-secondary-color text-truncate d-inline-block " (click)="changeRoute(params)">{{params.value}}</a>
    <span *ngIf="!params.value" class="text-dark">&#8212;</span>
  </div>
</ng-container>
<ng-template #noStatus>
<div *ngIf="!isAddRFQIcons" class="d-flex align-items-center gap-2 d-inline-block">
  <!-- Checked Circle -->
  <svg *ngIf="params.data?.priority" 
       class="cursor-pointer"
       (click)="onPriorityClick()"
       id="Group_43993" data-name="Group 43993" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
    <g id="Ellipse_85" data-name="Ellipse 85" fill="none" stroke="#4eabe1" stroke-width="1">
      <circle cx="15" cy="15" r="15" stroke="none"/>
      <circle cx="15" cy="15" r="14.5" fill="none"/>
    </g>
    <g id="tick" transform="translate(9.854 11.261)">
      <g id="Group_1173" data-name="Group 1173" transform="translate(0 0)">
        <path id="Path_941" data-name="Path 941" d="M195.173,420.428a.408.408,0,0,1-.289-.119l-2.815-2.815a.408.408,0,0,1,.576-.576l2.527,2.527,6.374-6.374a.408.408,0,0,1,.576.576l-6.662,6.662A.4.4,0,0,1,195.173,420.428Z" transform="translate(-191.95 -412.95)" fill="#4eabe1" stroke="#4eabe1" stroke-width="0.5"/>
      </g>
    </g>
  </svg>

  <!-- Empty Circle -->
  <svg *ngIf="!params.data?.priority" 
       class="cursor-pointer"
       (click)="onPriorityClick()"
       id="Group_42810" data-name="Group 42810" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
    <g id="Ellipse_85" data-name="Ellipse 85" fill="none" stroke="#8b9daa" stroke-width="1">
      <circle cx="15" cy="15" r="15" stroke="none" />
      <circle cx="15" cy="15" r="14.5" fill="none" />
    </g>
  </svg>
  <!-- Quantity -->
  <label *ngIf="params.data?.priority" class="font-16 text-secondary-color mb-0">
    {{ params.data?.priority }}
  </label>
</div>

<ng-container *ngIf="isAddRFQIcons">
    <div class="d-inline-flex align-items-center ms-4 cursor-pointer"
      (click)="!(params.data.canToggleIncludeInRfq) && onAddRemoveRFQClick($event)">
    <span>
      <svg id="Group_43553" data-name="Group 43553" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
        viewBox="0 0 24 24">
        <path id="Path_1799" data-name="Path 1799"
          d="M12.047,0A12.047,12.047,0,0,0,0,11.953,12.127,12.127,0,0,0,12.047,24a12,12,0,0,0,0-24Zm6.328,13.359H13.453v5.016a1.406,1.406,0,0,1-2.812,0V13.359H5.625a1.406,1.406,0,0,1,0-2.812h5.016V5.625a1.406,1.406,0,0,1,2.813,0v4.922h4.922a1.406,1.406,0,0,1,0,2.813Z"
          [attr.fill]="isAlreadyInRFQ === false ? '#e9edf2' : '#0067ac'" />
      </svg>
    </span>
    </div>
</ng-container>
